import { mapBloomreachLinks } from "./use-bloomreach-links.js";
import { useBloomreachPageModels } from "./use-bloomreach-page-models.js";
import { useBrPageContext } from "../../context/context/context.js";
import { parseBloomreachImage } from "../../utils/utils/parse-bloomreach-image.js";
import { getBrPageContent } from "../../utils/utils/get-br-page-content.js";
const useBloomreachDeliveryInfo = () => {
  const page = useBrPageContext();
  const pageModels = useBloomreachPageModels();
  const deliveryDocumentContent = getBrPageContent(page, pageModels?.deliveryInfo);
  if (!deliveryDocumentContent) {
    console.warn(
      `Cannot find main content for Delivery Info. Got: ${deliveryDocumentContent} for $ref: ${pageModels?.deliveryInfo?.$ref}`
    );
    return void 0;
  }
  const {
    deliveryItems: deliveryItemsRefs = [],
    description,
    link: brLink,
    linkHint,
    title
  } = deliveryDocumentContent;
  const brLinks = brLink ? [brLink] : [];
  const [link] = mapBloomreachLinks(brLinks, page);
  const deliveryItemsContents = deliveryItemsRefs.map(
    (ref) => getBrPageContent(page, ref)
  );
  const items = deliveryItemsContents.filter((deliveryItemContent) => !!deliveryItemContent?.title).map((deliveryItemContent) => ({
    description: deliveryItemContent?.description.value || "",
    id: deliveryItemContent?.id || "",
    image: parseBloomreachImage(deliveryItemContent?.image),
    price: deliveryItemContent?.price || "",
    title: deliveryItemContent?.title || ""
  }));
  return {
    items,
    description: description?.value || "",
    link,
    linkHint,
    title
  };
};
export {
  useBloomreachDeliveryInfo
};
//# sourceMappingURL=use-bloomreach-delivery-info.js.map
